import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("checking");

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/auth/me`);
      setUser(res.data);
      setStatus("authenticated");
    } catch (e) {
      if (e?.response?.status === 403) {
        setStatus("unauthorized");
      } else {
        setStatus("unauthenticated");
      }
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const exchangeSession = useCallback(async (sessionId) => {
    await axios.post(`${API}/auth/session`, { session_id: sessionId });
    await checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    await axios.post(`${API}/auth/logout`);
    setUser(null);
    setStatus("unauthenticated");
  }, []);

  return (
    <AuthContext.Provider value={{ user, status, exchangeSession, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
